import * as React from 'react';
import { AuditForm, AuditModal } from '../../../auditmodal/components/AuditModal';
import { AuditTrailActionEnum } from '../../../misc/api/ApiAuditActions';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';

interface BatchForBoutModalProps {
    onClose: () => void;
}

export const BatchForBoutModal = (props: BatchForBoutModalProps) => {
    const client = useWebPortalApiClient();
    const [submitting, setSubmitting] = React.useState(false);

    const onSubmit = async (auditForm: AuditForm) => {
        setSubmitting(true);
  
        await client.client.batchProcessCoughSessions({
            auditAnnotation: auditForm.Annotation,
        });

        await client.client.postAuditTrailEvent({
            summary: `The batch processing of cough sessions has been triggered.`,
            auditAction: AuditTrailActionEnum.BatchProcessCoughSessionsTriggered,
            userAnnotation: auditForm.Annotation,
        });

        setSubmitting(false);
        props.onClose();
    }

    return (
        <AuditModal header="Re-process all sessions for Bout Analysis"
            isSubmitting={submitting}
            warning="Are you sure you wish to continue? This will schedule all sessions for bout analysis re-processing?"
            onClose={() => props.onClose()}
            onSubmit={(annotation) => onSubmit(annotation)}
        />
    );
}
